var imat = imat || {};

imat.master = {
    init: function () {
        imat.master.initSubscriptions();
        imat.master.initKeepSessionAlive();
        imat.master.Cookies.init();
    },

    initKeepSessionAlive: function () {
        setInterval(imat.master.keepSessionAlive, 300000);
    },

    keepSessionAlive: function () {
        $.ajax({
            type: "GET",
            url: "/keepsessionalive",
            cache: false
        });
    },

    initSubscriptions: function () {
        $("#frmSubscription a").click(function (event) {
            if ($("#frmSubscription #joinNewsletter").valid()) {
                $("#frmSubscription").submit();
                return false;
            }
            return false;
        });

        $("#frmSubscription").validate({
            rules: {
                SubscriberEmail: {
                    email: true,
                    required: true
                }
            },
            messages: {
                SubscriberEmail: ""
            },
            highlight: function (element, errorClass/*, validClass*/) {
                imat.master.view.enableSubscriptionButton(false);
            },
            unhighlight: function (element, errorClass/*, validClass*/) {
                imat.master.view.enableSubscriptionButton(true);
            },
            //tired of this shit
            onkeyup: function (element) { this.element(element); },
            onfocusout: function (element) { this.element(element); }
        });

        imat.master.view.initSubscriptionField();
    }

};


imat.master.view = {

    initSubscriptionField: function () {

        var watermarkText = $("#frmSubscription input#joinNewsletter").attr("title");

        if (!$("#frmSubscription input#joinNewsletter").val()) {
            $("#frmSubscription input#joinNewsletter").val(watermarkText);
            imat.master.view.enableSubscriptionButton(false);
        }

        $("#frmSubscription input#joinNewsletter").focus(function () {
            if ($(this).val() === watermarkText) {
                $(this).val("");
            }
            $(this).addClass("active");
        });

        $("#frmSubscription input#joinNewsletter").blur(function () {
            if (!$(this).val()) {
                $(this).val(watermarkText);
                $(this).removeClass("active");
            }
        });

    },

    enableSubscriptionButton: function (enable) {
        if (enable) {
            $("#frmSubscription a").removeClass("btn-disable");
        } else {
            $("#frmSubscription a").addClass("btn-disable");
        }
    }
};

imat.master.Cookies = function () {

    function checkCookies() {
        $.get("/Home/CheckCookies", function (data) {
            if (!data.isCookieCheckSuccessful) {
                onCookiesCheckFailed();
            }
        });
    }

    function onCookiesCheckFailed() {
        $("#blockedCookiesAlert").slideDown(150).addClass('is-active');
    }

    return {
        init: checkCookies
    }
}();


$(document).ready(function () {
    imat.master.init();
});